import React, { useEffect, useState } from "react";
import { JSONTree } from "react-json-tree";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import loginUser from "../../utils/authService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import {
  REGISTER_API_URL,
  USER_CREATE_URL,
  USER_DETAILS_URL,
  USER_UPDATE_URL,
  USER_IMAGE_URL,
} from "../../utils/Constant";

const CreateUserPage = () => {
  const authToken = useSelector((state) => state.token);
  const navigate = useNavigate();
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formDataAll, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    pinCode: "",
    image: null,
    status: "",
    role: "",
    creditCardNumber: "",
    creditCardType: "",
    creditCardExpiryMonth: "",
    creditCardExpiryYear: "",
    creditCardCVV: "",
    response: {},
  });

  //console.log("userId", userId);

  //console.log("response>>>>>>>>>>>>>>>>>>>>>", formDataAll.response);
  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    }
  }, []);

  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }

    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };

  useEffect(() => {
    // setNewCategoryId(categoryId)
    if (authToken) {
      const fetchDetails = async () => {
        try {
          // setNewCategoryId(categoryId)
          if (userId) {
            showToast(true, "Data Loading. Please wait..", "info");
          }
          const response = await fetch(`${USER_DETAILS_URL}/${userId}`, {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
            },
          });
          const data = await response.json();
          //console.log("details:::1234", data);

          setFormData({
            username: data.data.username || "",
            email: data.data.email || "",
            password: "",
            firstName: data.data.firstName || "",
            lastName: data.data.lastName || "",
            phone: data.data.phone || "",
            address: data.data.address || "",
            pinCode: data.data.pinCode || "",
            image: data.data.image || null,
            status: data.data.isActive ? 1 : 0,
            role: data.data.role || "",

            response: data.data || [],

            creditCardNumber: data.data.creditCardNumber || "",
            creditCardExpiryMonth: data.data.creditCardExpiryMonth || "",
            creditCardExpiryYear: data.data.creditCardExpiryYear || "",
            creditCardType: data.data.creditCardType || "",
            creditCardCVV: data.data.creditCardCVV || "",

            confirmPassword: "",
          });
          setImagePreview(
            data.data.image ? URL.createObjectURL(data.data.image) : null
          );
        } catch (error) {
          //console.error("Error fetching product:", error);
        }
      };
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formDataAll, [name]: value });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Update the state with the image preview URL
    setImagePreview(file ? URL.createObjectURL(file) : null);
    // Update the state with the selected file
    setFormData({ ...formDataAll, image: file });
  };
  //console.log("authToken", authToken);

  const selectedData = {
    username: formDataAll.username,
    email: formDataAll.email,
    password: formDataAll.password,
    confirmPassword: formDataAll.confirmPassword,
    firstName: formDataAll.firstName,
    lastName: formDataAll.lastName,
    phone: formDataAll.phone,
    address: formDataAll.address,
    pinCode: formDataAll.pinCode,
    image: formDataAll.image,
    role: formDataAll.role,
    status: formDataAll.status,
  };

  //console.log("selectedData>>>>>>>>>", selectedData);

  //console.log("formDataAll.role,", formDataAll.status);

  const passwordsMatch = () => {
    return formDataAll.password === formDataAll.confirmPassword;
  };

  const handleSubmit = async (event) => {
    //console.log("first");
    event.preventDefault();

    if (!passwordsMatch()) {
      showToast(true, "Passwords do not match", "error");
      return;
    }

    try {
      setLoading(true);
      showToast(true, "In Progress. Please wait..", "info");
      let data = new FormData();
      data.append("username", formDataAll.username);
      data.append("email", formDataAll.email);
      data.append("password", formDataAll.password);
      data.append("firstName", formDataAll.firstName);
      data.append("lastName", formDataAll.lastName);
      data.append("phone", formDataAll.phone);
      data.append("image", formDataAll.image);
      data.append("address", formDataAll.address);
      data.append("pinCode", formDataAll.pinCode);
      data.append("role", formDataAll.role);
      data.append("isActive", formDataAll.status);
      data.append("creditCardNumber", formDataAll.creditCardNumber);
      data.append("creditCardExpiryMonth", formDataAll.creditCardExpiryMonth);
      data.append("creditCardExpiryYear", formDataAll.creditCardExpiryYear);
      data.append("creditCardType", formDataAll.creditCardType);
      data.append("creditCardCVV", formDataAll.creditCardCVV);

      let APIUrl = userId ? `${USER_UPDATE_URL}/${userId}` : USER_CREATE_URL;
      //console.log("APIUrl", APIUrl);
      const response = await fetch(APIUrl, {
        method: userId ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
        body: data,
      });
      const responseData = await response.json();

      // Handle success or display error messages
      setLoading(false);
      if (response.ok) {
        showToast(true, responseData.msg, "success");
      } else {
        showToast(
          "Loading:",
          "An error occurred." + responseData.error,
          "error"
        );
      }
    } catch (error) {
      console.error("User Creation Error:", error.message);
      showToast(true, error.message, "error");
      setLoading(false);
      // Handle network errors
    }
  };

  return (
    <DashboardLayout>
      <div class="row">
        <div class="col-md-7">
          {/* <div className=""> */}
          {/* <div className="card-header">
              <h3 className="card-title">
                <b>Custom Fields</b>
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i className="fas fa-minus" />
                </button>
              </div>
            </div> */}
          {/* <div className="card-body">
              <JSONTree src={formDataAll.response} />
            </div> */}
          {/* </div> */}

          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Add User</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="firstName">
                        First Name<span className="error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        placeholder="First Name"
                        value={formDataAll.firstName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="lastName">
                        Last Name<span className="error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        name="lastName"
                        placeholder="Last Name"
                        value={formDataAll.lastName}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="username">
                        Username<span className="error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        name="username"
                        placeholder="Username"
                        value={formDataAll.username}
                        disabled={userId ? true : false}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="email">
                        Email<span className="error">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email"
                        disabled={userId ? true : false}
                        value={formDataAll.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="phone">
                        Phone<span className="error">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder="Phone"
                        value={formDataAll.phone}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="role">
                        Role<span className="error">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="role"
                        name="role"
                        value={formDataAll.role}
                        onChange={handleInputChange}
                        disabled={userId ? true : false}
                      >
                        <option value="admin">Admin</option>
                        <option value="customer">Customer</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="address">
                    Address<span className="error">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    id="address"
                    name="address"
                    placeholder="Address"
                    value={formDataAll.address}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="pinCode">
                        PIN Code<span className="error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="pinCode"
                        name="pinCode"
                        placeholder="PIN Code"
                        value={formDataAll.pinCode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="status">
                        Status<span className="error">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="status"
                        name="status"
                        value={formDataAll.status}
                        onChange={handleInputChange}
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                      {/* <input
                        type="text"
                        className="form-control"
                        id="status"
                        name="status"
                        placeholder="Status"
                        value={formDataAll.status}
                        onChange={handleInputChange}
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="image">
                        User Image<span className="error">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control-file"
                        id="image"
                        name="image"
                        onChange={handleFileChange}
                      />
                      {/* Display image preview */}
                      {imagePreview ? (
                        <div>
                          <br></br>
                          <img
                            src={imagePreview}
                            alt="Preview"
                            style={{ width: "100%", height: "200px" }}
                          />
                        </div>
                      ) : (
                        <div>
                          <br></br>
                          <img
                            src={`${USER_IMAGE_URL}${formDataAll.image}`}
                            alt="Preview"
                            style={{ "border-radius": "5px", height: "120px" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {userId ? (
                      <>{loading ? "Updating User..." : "Update User"}</>
                    ) : (
                      <>{loading ? "Adding User..." : "Add User"}</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div className="card card-default">
            <div className="card-header">
              <h3 className="card-title">
                <b>Password</b>
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i className="fas fa-minus" />
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="password">
                  Password {!userId ? <span className="error">*</span> : ""}
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  placeholder="Password"
                  value={formDataAll.password}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">
                  Confirm Password{" "}
                  {!userId ? <span className="error">*</span> : ""}
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formDataAll.confirmPassword}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {/* /.card-body */}
          </div>
          <div className="card card-default  collapsed-card">
            <div className="card-header">
              <h3 className="card-title">
                <b>Credit Card Details</b>
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i className="fas fa-plus" />
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="cc">Credit Card</label>
                <input
                  type="text"
                  className="textarea form-control"
                  placeholder="---- ---- ---- ----"
                  id="cc"
                  name="creditCardNumber"
                  value={formDataAll.creditCardNumber}
                  onChange={handleInputChange}
                  disabled={userId ? true : false}
                />
              </div>

              <div className="form-group">
                <label htmlFor="date">creditCardExpiryMonth</label>
                <input
                  input="text"
                  className="textarea form-control"
                  placeholder="MM"
                  id="date"
                  name="creditCardExpiryMonth"
                  value={formDataAll.creditCardExpiryMonth}
                  onChange={handleInputChange}
                  disabled={userId ? true : false}
                />
              </div>
              <div className="form-group">
                <label htmlFor="date">creditCardExpiryYear</label>
                <input
                  input="text"
                  className="textarea form-control"
                  placeholder="YYYY"
                  id="date"
                  name="creditCardExpiryYear"
                  value={formDataAll.creditCardExpiryYear}
                  onChange={handleInputChange}
                  disabled={userId ? true : false}
                />
              </div>
              <div className="form-group">
                <label htmlFor="date">Card Type</label>
                <input
                  input="text"
                  className="textarea form-control"
                  placeholder="MM/YY"
                  id="date"
                  name="creditCardType"
                  value={formDataAll.creditCardType}
                  onChange={handleInputChange}
                  disabled={userId ? true : false}
                />
              </div>
              <div className="form-group">
                <label htmlFor="cvv">Enter CVV</label>

                <input
                  input="text"
                  className="textarea form-control"
                  placeholder="Enter CVV"
                  id="cvv"
                  name="creditCardCVV"
                  value={formDataAll.creditCardCVV}
                  onChange={handleInputChange}
                  disabled={userId ? true : false}
                />
              </div>
            </div>
            {/* /.card-body */}
          </div>

          {userId ? (
            <div className="card card-default collapsed-card">
              <div className="card-header">
                <h3 className="card-title">
                  <b>Custom Fields</b>
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                    data-toggle="tooltip"
                    title="Collapse"
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </div>
              <div className="card-body">
                <JSONTree data={formDataAll.response} />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CreateUserPage;
